import { useStyles } from "./GamingLoading.style";
import { StaticImage } from "../StaticImage";
import { assetsImages } from "../../../models/theme";
import { THEME_CONFIG } from "../../../constants/env";

const GamingLoading: React.FC = () => {
  const classes = useStyles();
  const dimension = THEME_CONFIG.pages?.splash?.dimension;
  const width =
    typeof dimension?.width === "number" && dimension.width > 0
      ? dimension.width
      : 37;
  const height =
    typeof dimension?.height === "number" && dimension.height > 0
      ? dimension.height
      : 38;

  return (
    <div className={classes.root}>
      <StaticImage
        src={assetsImages.loadingLogo["1x"]}
        src2x={assetsImages.loadingLogo["2x"]}
        src3x={assetsImages.loadingLogo["3x"]}
        alt="gaming-loading"
        width={width}
        height={height}
      />
    </div>
  );
};

export default GamingLoading;
